import { Notification } from '@mantine/core'
import { serviceCenterStore } from 'App/ServiceCenter/store/serviceCenterStore'
import { IconClose } from 'components/icons/IconClose'
import { IconNetworkOffline } from 'components/icons/IconNetworkOffline'
import { translate } from 'i18n/i18n'
import React, { useEffect } from 'react'
import { Contents } from './Contents'

export const OfflineContentDownloadBanner = () => {
  const { downloadStatus, isBannerOpened } = serviceCenterStore.useSelector((s) => s.offlineContents)

  useEffect(() => {
    if (downloadStatus === 'success') {
      setTimeout(() => {
        handleClose()
      }, 3000)
    }
  }, [downloadStatus])

  const handleClose = () => {
    serviceCenterStore.actions.setIsOfflineContentBannerOpened(false)

    serviceCenterStore.actions.setOfflineContentsDownloadStatus('default')
  }

  if (!isBannerOpened) return null

  return (
    <Notification
      onClose={handleClose}
      title={
        <div
          style={{ fontSize: '18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
          <div>
            <span style={{ fontSize: '20px', display: 'inline-block', marginRight: 5 }}>
              <IconNetworkOffline />
            </span>{' '}
            {translate.phrases.placeholder('Offline Functionality')}
          </div>

          <button
            style={{ background: 'none', border: 'none', padding: '4px 5px 0', marginRight: -5 }}
            onClick={handleClose}
          >
            <span style={{ fontSize: '14px' }}>
              <IconClose />
            </span>
          </button>
        </div>
      }
      css={{
        position: 'absolute',
        paddingTop: 'calc(10px + env(safe-area-inset-top))',
        paddingBottom: 'calc(10px + env(safe-area-inset-bottom))',
        paddingRight: '10px',
        paddingLeft: '20px',
        top: 0,
        zIndex: 10000,
        width: '100%',
        border: 'none',
        borderRadius: 0,
      }}
      color="white"
      withCloseButton={false}
    >
      <Contents />
    </Notification>
  )
}
